import { isAxiosError } from 'axios';
import { ApiError, SPINE_LINK_BLOCKED_CODE } from '@/react/api/client';

interface SpineBlockedBody {
  message?: string;
  data?: {
    code?: string;
    kind?: string;
    event_ids?: string[];
    issues?: Array<{ kind?: string; event_ids?: string[] }>;
  };
}

export type SpineLinkBlockedKind = 'cancelled' | 'deleted';

export interface SpineLinkBlockedIssue {
  kind: SpineLinkBlockedKind;
  eventIds: string[];
}

export interface SpineLinkBlocked {
  /** Every dead-link kind and the events affected by it. */
  issues: SpineLinkBlockedIssue[];
  message?: string;
}

function issue(kind: string | undefined, eventIds: unknown): SpineLinkBlockedIssue {
  return {
    kind: kind === 'deleted' ? 'deleted' : 'cancelled',
    eventIds: Array.isArray(eventIds) ? eventIds.filter((id): id is string => typeof id === 'string') : [],
  };
}

export function spineLinkBlocked(error: unknown): SpineLinkBlocked | null {
  const body =
    error instanceof ApiError
      ? (error.data as SpineBlockedBody | undefined)
      : isAxiosError(error)
        ? (error.response?.data as SpineBlockedBody | undefined)
        : undefined;
  if (body?.data?.code !== SPINE_LINK_BLOCKED_CODE) return null;

  const first = issue(body.data.kind, body.data.event_ids);
  const groupedIssues = Array.isArray(body.data.issues)
    ? body.data.issues
        .map((entry) => issue(entry.kind, entry.event_ids))
        .filter((entry) => entry.eventIds.length > 0)
    : [];
  const issues = groupedIssues.length > 0 ? groupedIssues : [first];

  return {
    issues,
    message: body.message,
  };
}

export function spineLinkBlockedKind(error: unknown): SpineLinkBlockedKind | null {
  return spineLinkBlocked(error)?.issues[0]?.kind ?? null;
}
